export const toSnakeCase = (string) => {
  return string.split('_').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join('');
}
